'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DataLoader = function () {
  function DataLoader(firebase, rootLabel, label) {
    var isArray = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    _classCallCheck(this, DataLoader);

    this.firebase = firebase;
    this.rootLabel = rootLabel;
    this.label = label;
    this.isArray = isArray;
  }

  _createClass(DataLoader, [{
    key: 'startSyncing',
    value: function startSyncing(id) {
      var _this = this;

      return function (dispatch) {
        _this.listener = function (snapshot) {
          _this.onFirebaseUpdate(id, snapshot, dispatch);
        };

        // Start syncing list of teams
        _this.initLoaders(id);
      };
    }
  }, {
    key: 'initLoaders',
    value: function initLoaders(id) {
      var dbRef = this.firebase.database().ref(this.rootLabel + '/' + id + '/' + this.label);
      this.dbRef = this.getFinalRef(dbRef);
      this.dbRef.on('value', this.listener);
    }
  }, {
    key: 'getFinalRef',
    value: function getFinalRef(dbRef) {
      return dbRef;
    }
  }, {
    key: 'onFirebaseUpdate',
    value: function onFirebaseUpdate(id, snapshot, dispatch) {
      var value = this.isArray ? [] : snapshot.val();
      if (this.isArray) {
        snapshot.forEach(function (childSnapshot) {
          var obj = childSnapshot.val();
          if (!obj.delete) {
            value.push(Object.assign({ dbKey: childSnapshot.key }, obj));
          }
        });
      } else {
        for (var key in value) {
          if (value[key].delete) {
            delete value[key];
          }
        }
      }

      dispatch(this.getReduxAction(id, value));
    }
  }, {
    key: 'getReduxAction',
    value: function getReduxAction(id, value) {
      return {
        type: 'FIREBASE_' + this.rootLabel.toUpperCase() + '_UPDATE_VALUE',
        label: this.label,
        value: value,
        id: id
      };
    }
  }, {
    key: 'stopSyncing',
    value: function stopSyncing() {
      if (this.dbRef) {
        this.detachLoaders();
        this.listener = undefined;
      }
    }
  }, {
    key: 'detachLoaders',
    value: function detachLoaders() {
      this.dbRef.off('value', this.listener);
      this.dbRef = null;
    }
  }]);

  return DataLoader;
}();

module.exports = DataLoader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fibo-app/fibo-collab-shared/build/clients/loaders/DataLoader.js
// module id = 223
// module chunks = 0